import { render, staticRenderFns } from "./IstarshineForm.vue?vue&type=template&id=1dbb50c4"
import script from "./IstarshineForm.vue?vue&type=script&lang=js"
export * from "./IstarshineForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./IstarshineForm.vue?vue&type=style&index=1&id=1dbb50c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports